export default "__VITE_ASSET__6aa87854__"